<ng-container *ngIf="size === iconSize.regular">
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
       fill="red" stroke="red" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    <rect width="4" height="18" x="10" y="3"></rect>
    <rect width="18" height="4" x="3" y="10"></rect>
  </svg>
</ng-container>

<ng-container *ngIf="size === iconSize.small">
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"
       fill="red" stroke="red" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    <rect width="4" height="18" x="10" y="3"></rect>
    <rect width="18" height="4" x="3" y="10"></rect>
  </svg>
</ng-container>

<ng-container *ngIf="size === iconSize.extraSmall">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
       fill="red" stroke="red" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
    <rect width="4" height="18" x="10" y="3"></rect>
    <rect width="18" height="4" x="3" y="10"></rect>
  </svg>
</ng-container>
